/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Embed_Captions_Confirm_Total_LabelInputs */

const en_embed_captions_confirm_total_label = /** @type {(inputs: Embed_Captions_Confirm_Total_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total Cost:`)
};

const fr_embed_captions_confirm_total_label = /** @type {(inputs: Embed_Captions_Confirm_Total_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cout total :`)
};

const de_embed_captions_confirm_total_label = /** @type {(inputs: Embed_Captions_Confirm_Total_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gesamtkosten:`)
};

const it_embed_captions_confirm_total_label = /** @type {(inputs: Embed_Captions_Confirm_Total_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Costo totale:`)
};

const ru_embed_captions_confirm_total_label = /** @type {(inputs: Embed_Captions_Confirm_Total_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Общая стоимость:`)
};

const es_embed_captions_confirm_total_label = /** @type {(inputs: Embed_Captions_Confirm_Total_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Costo total:`)
};

const zh_cn2_embed_captions_confirm_total_label = /** @type {(inputs: Embed_Captions_Confirm_Total_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`总成本：`)
};

const ja_embed_captions_confirm_total_label = /** @type {(inputs: Embed_Captions_Confirm_Total_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`合計費用:`)
};

const hi_embed_captions_confirm_total_label = /** @type {(inputs: Embed_Captions_Confirm_Total_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कुल लागत:`)
};

const pt_pt2_embed_captions_confirm_total_label = /** @type {(inputs: Embed_Captions_Confirm_Total_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Custo total:`)
};

/**
* | output |
* | --- |
* | "Total Cost:" |
*
* @param {Embed_Captions_Confirm_Total_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const embed_captions_confirm_total_label = /** @type {((inputs?: Embed_Captions_Confirm_Total_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embed_Captions_Confirm_Total_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_embed_captions_confirm_total_label(inputs)
	if (locale === "de") return de_embed_captions_confirm_total_label(inputs)
	if (locale === "it") return it_embed_captions_confirm_total_label(inputs)
	if (locale === "ru") return ru_embed_captions_confirm_total_label(inputs)
	if (locale === "es") return es_embed_captions_confirm_total_label(inputs)
	if (locale === "zh-CN") return zh_cn2_embed_captions_confirm_total_label(inputs)
	if (locale === "ja") return ja_embed_captions_confirm_total_label(inputs)
	if (locale === "hi") return hi_embed_captions_confirm_total_label(inputs)
	if (locale === "pt-PT") return pt_pt2_embed_captions_confirm_total_label(inputs)
	return en_embed_captions_confirm_total_label(inputs)
});